// RadioGroup.jsx
import React from "react";

export default function RadioGroup({ value, onChange, options = [] }) {
  const ACCENT = "#169FA7";

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = value === opt.value;
        const Icon = opt.icon;

        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={[
              "inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm transition",
              "border",
              active
                ? "text-white"
                : "text-neutral-700 dark:text-neutral-300 border-neutral-200 dark:border-neutral-800 bg-white/70 dark:bg-neutral-900/70 hover:bg-neutral-50 dark:hover:bg-neutral-800/60",
            ].join(" ")}
            style={{
              background: active ? ACCENT : undefined,
              borderColor: active ? ACCENT : undefined,
            }}
          >
            {Icon && (
              <Icon
                size={16}
                className={active ? "text-white" : "text-neutral-500"}
              />
            )}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
